import { IUser } from "../../../types/user/iuser.interface";
import { IRegionResults } from "../../../types/search/iregion-results.interface";
import { mergedApprovalStatuses } from "../../../types/approval-status/approval-statuses.constant";
import { toDatePickerValue } from "../../../utils/date-format.utils";

import { IOptionLists } from "../components/filter-chips/filter-chips.props";

import { paramMappersMap, valueFindersMap } from "./filter.types";
import { notFlag } from "./filters.constants";

const paramMappers = (): paramMappersMap => ({
  assignee: mapIdBasedParam,
  creativePrime: mapIdBasedParam,
  briefOwner: mapIdBasedParam,
  flyerOwner: mapIdBasedParam,
  regions: mapIdBasedParam,
  template: mapStringBasedParam,
  status: mapStringBasedParam,
});

const valueFinders = (): valueFindersMap => ({
  assignee: findUserValue,
  creativePrime: findUserValue,
  briefOwner: findUserValue,
  flyerOwner: findUserValue,
  regions: findRegionValue,
  template: findTemplateValue,
  status: findStatusValue,
  dateFrom: findDateValue,
  dateTo: findDateValue,
});

const findDateValue = (name: string, value: any) => {
  return toDatePickerValue(value[0]);
};

const findRegionValue = (name: string, value: any, options: IOptionLists) => {
  const val: number[] = value.map((v: string) => Number(v));
  return options.regions?.filter((r: IRegionResults) => val.includes(r.id));
};

const findStatusValue = (name: string, value: any) => {
  return mergedApprovalStatuses.find((s) => value.includes(s.value)) ?? null;
};

const findTemplateValue = (name: string, value: any, options: IOptionLists) => {
  return options.templates?.find((t) => value.includes(t.value)) ?? null;
};

const findUserValue = (name: string, value: any, options: IOptionLists) => {
  const val: number[] = value.map((v: string) => Number(v));
  return options.users?.find((u: IUser) => val.includes(u.id)) ?? null;
};

const findValue = (name: string, value: any, options: IOptionLists) => {
  const finder = valueFinders()[name];
  if (finder) {
    return finder(name, value, options);
  }

  return value[0];
};

export const reduceValues = (params: any, options: IOptionLists) => {
  return Object.keys(params).reduce(
    (acc, name) => ({
      ...acc,
      [name]: findValue(name, params[name], options),
    }),
    {}
  );
};

const mapIdBasedParam = (name: string, value: any) => ({
  name,
  value: value?.map((v: any) => v.id).join(",") ?? null,
});

const mapStringBasedParam = (name: string, value: any, inverted?: boolean) => ({
  name,
  value: value ? (inverted ? notFlag : "") + value?.map((v: any) => v.value).join(",") : null,
});

export const valuesToParams = (values: any) => {
  const keys = Object.keys(values);

  return keys
    .map((name) => {
      if (name.includes("Inverted")) {
        return false;
      }

      let value = values[name];
      value = value === null || Array.isArray(value) ? value : [value];

      const mapper = paramMappers()[name];
      if (mapper) {
        return mapper(name, value, Boolean(values[`${name}Inverted`]));
      }

      const inverted = Boolean(values[`${name}Inverted`]);
      return { name, value: (inverted ? notFlag : "") + value[0] };
    })
    .filter((param) => param);
};
